import type React from "react";
import { createContext, useContext } from "react";

type MenuLinkType = React.ElementType | null;

const MenuLinkContext = createContext<MenuLinkType>(null);

interface MenuLinkProviderProps {
  component: React.ElementType;
  children: React.ReactNode;
}

export const MenuLinkProvider = ({
  component,
  children,
}: MenuLinkProviderProps) => {
  return (
    <MenuLinkContext.Provider value={component}>
      {children}
    </MenuLinkContext.Provider>
  );
};

export const useMenuLink = () => {
  const context = useContext(MenuLinkContext);

  if (context === null) {
    return "a";
  }

  return context;
};
